import { IVacationCarryOverRequestState } from '@/store/vacation-carry-over-request';
import { IVacationCarryOverRequestMutations } from './mutations.types';
import {
  IUserData,
  IVacationCarryOverRequestCommentData,
  IVacationCarryOverRequestData
} from '@/models';
import { ITransition } from '@/models/transition';

export const mutations: IVacationCarryOverRequestMutations = {
  SET_COUNT(state: IVacationCarryOverRequestState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IVacationCarryOverRequestState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IVacationCarryOverRequestState): void {
    state.count -= 1;
  },

  SET_VACATION_CARRY_OVER_REQUESTS(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestData[]
  ): void {
    state.vacationCarryOverRequests = payload;
  },

  ADD_VACATION_CARRY_OVER_REQUEST(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestData
  ): void {
    state.vacationCarryOverRequests.unshift(payload);
  },

  UPDATE_VACATION_CARRY_OVER_REQUEST(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestData
  ): void {
    const index = state.vacationCarryOverRequests.findIndex(
      (vacationCarryOver: IVacationCarryOverRequestData) =>
        vacationCarryOver.id === payload.id
    );

    state.vacationCarryOverRequests.splice(index, 1, payload);
  },

  REMOVE_VACATION_CARRY_OVER_REQUEST(
    state: IVacationCarryOverRequestState,
    payload: number
  ): void {
    const index = state.vacationCarryOverRequests.findIndex(
      (vacationCarryOver: IVacationCarryOverRequestData) =>
        vacationCarryOver.id === payload
    );

    state.vacationCarryOverRequests.splice(index, 1);
  },

  SET_VACATION_CARRY_OVER_REQUEST_ACTIVITIES(
    state: IVacationCarryOverRequestState,
    payload: ITransition[]
  ): void {
    state.activities = payload;
  },

  //comments
  SET_VACATION_CARRY_OVER_REQUEST_COMMENTS(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_VACATION_CARRY_OVER_REQUEST_COMMENT(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_VACATION_CARRY_OVER_REQUEST_COMMENT(
    state: IVacationCarryOverRequestState,
    payload: IVacationCarryOverRequestCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IVacationCarryOverRequestCommentData) =>
        comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_VACATION_CARRY_OVER_REQUEST_COMMENT(
    state: IVacationCarryOverRequestState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IVacationCarryOverRequestCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_LAST_CREATED_VACATION_CARRY_OVER_REQUEST_COMMENT_ID(
    state: IVacationCarryOverRequestState,
    payload: number
  ): void {
    state.lastCreatedVacationCarryOverRequestCommentId = payload;
  },

  SET_MENTIONABLE_USERS(
    state: IVacationCarryOverRequestState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_PROMISE(
    state: IVacationCarryOverRequestState,
    payload: Promise<any>
  ): void {
    state.lastPromise = payload;
  }
};
